const services = [
  {
    image: 'https://readdy.ai/api/search-image?query=medical%20professional%20consulting%20session%20with%20client%20in%20modern%20clinical%20office%2C%20regenerative%20medicine%20specialist%20explaining%20treatment%20plan%20on%20tablet%20screen%2C%20professional%20healthcare%20consultation%2C%20clean%20bright%20white%20office%20background%2C%20natural%20lighting%2C%20business%20professional%20attire%2C%20high%20quality%20photography&width=400&height=300&seq=3&orientation=landscape',
    title: 'Expert Consulting',
    description: 'Strategic guidance from seasoned Regenerative Medicine professionals to optimize protocols and streamline your operations.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=healthcare%20professionals%20networking%20at%20medical%20conference%2C%20group%20of%20doctors%20and%20medical%20specialists%20shaking%20hands%20discussing%20regenerative%20medicine%20partnerships%2C%20professional%20medical%20industry%20networking%20event%2C%20bright%20modern%20venue%2C%20business%20formal%20attire%2C%20high%20quality%20photography&width=400&height=300&seq=4&orientation=landscape',
    title: 'Industry-Leading Connections',
    description: 'Access to our 10+ years of built relationships across pharmacy, telehealth, healthcare technology, legal support, and nationwide provider networks.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=medical%20education%20workshop%20with%20healthcare%20professionals%20in%20modern%20classroom%20setting%2C%20doctor%20presenting%20regenerative%20medicine%20training%20seminar%2C%20engaged%20students%20professionals%20in%20business%20attire%2C%20bright%20clean%20modern%20training%20room%2C%20whiteboard%20presentation%2C%20high%20quality%20photography&width=400&height=300&seq=5&orientation=landscape',
    title: 'Education & Training',
    description: 'Facilitating access to expert-led training on Regenerative Medicine therapies, their applications, and best-practice recommendations through our trusted partners.',
  },
];

export default function OurServices() {
  return (
    <section id="services" className="py-24 px-6" style={{ background: '#f8f9fc' }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-3">
            <span className="w-8 h-0.5 bg-red-500 inline-block" />
            <p className="text-red-600 text-sm font-semibold uppercase tracking-widest">Our Services</p>
            <span className="w-8 h-0.5 bg-red-500 inline-block" />
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Personalized Support for Healthcare Professionals
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">
            Discover our comprehensive range of services designed to empower healthcare professionals with the tools, knowledge, and connections they need to thrive.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-transform duration-300 cursor-pointer"
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-base font-bold text-red-600 mb-2">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{s.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
